import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-image-full-with-video.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var BannerMidPageImageFullWithVideo = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageImageFullWithVideo, _super);
    function BannerMidPageImageFullWithVideo(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageImageFullWithVideo.prototype.init = function () {
        var _this = this;
        this.SliderContainer = this.element.querySelector('.banner-mid-page-image-full-with-video__banner--swiper');
        this.SliderPagination = this.element.querySelector('.swiper-pagination');
        this.Slider = new Swiper(this.SliderContainer, {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
            pagination: {
                el: this.SliderPagination,
                type: 'bullets',
                clickable: true
            },
        });
        this.Slider.on('slideChange', function (event) {
            var videos = Array.from(_this.SliderContainer.querySelectorAll('.video'));
            videos.forEach(function (videoContainer) {
                var videosContent = videoContainer.querySelector('.video__player-content');
                videoContainer.classList.remove('video--playing');
                videosContent.innerHTML = '';
            });
        });
    };
    BannerMidPageImageFullWithVideo.prototype.bindEvents = function () {
    };
    return BannerMidPageImageFullWithVideo;
}(Base));
export { BannerMidPageImageFullWithVideo };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-image-full-with-video/banner-mid-page-image-full-with-video.component.ts
// module id = 768
// module chunks = 0